import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ErrorMessage } from 'shared/error-handling';
import { ReportType } from 'shared/report';
import { ReportDetails, ReportEditionListItem } from 'shared/report-model';
import { ReportTemplate } from 'shared/report-template/report-template-adapter/model';

import { ReportDetailsApiActionTypes } from '../models';

export const getReportSuccess = createAction(
    ReportDetailsApiActionTypes.getReportSuccess,
    props<{ report: ReportDetails }>(),
);

export const getReportFailure = createAction(
    ReportDetailsApiActionTypes.getReportFailure,
    props<{ errorMessage: ErrorMessage }>(),
);

export const activateReportFailure = createAction(
    ReportDetailsApiActionTypes.activateReportFailure,
    props<{ error: HttpErrorResponse; reportType: ReportType }>(),
);

export const activateReportSuccess = createAction(
    ReportDetailsApiActionTypes.activateReportSuccess,
    props<{ reportType: ReportType; reportId: string }>(),
);

export const getLatestReportTemplateSuccess = createAction(
    ReportDetailsApiActionTypes.getLatestReportTemplateSuccess,
    props<{ template: ReportTemplate }>(),
);

export const getLatestReportTemplateFailure = createAction(
    ReportDetailsApiActionTypes.getLatestReportTemplateFailure,
    props<{ errorMessage: ErrorMessage }>(),
);

export const getReportEditionListSuccess = createAction(
    ReportDetailsApiActionTypes.getReportEditionListSuccess,
    props<{ editions: ReportEditionListItem[] }>(),
);

export const getReportEditionListFailure = createAction(
    ReportDetailsApiActionTypes.getReportEditionListFailure,
    props<{ errorMessage: ErrorMessage }>(),
);

export const deleteReportSuccess = createAction(ReportDetailsApiActionTypes.deleteReportSuccess);

export const deleteReportFailure = createAction(
    ReportDetailsApiActionTypes.deleteReportFailure,
    props<{ errorMessage: ErrorMessage }>(),
);

export const updateReportSuccess = createAction(ReportDetailsApiActionTypes.updateReportSuccess);
export const updateReportFailure = createAction(
    ReportDetailsApiActionTypes.updateReportFailure,
    props<{ errorMessage: ErrorMessage }>(),
);
